//#region src/bite_log_freedom_pay_event.ts
var BiteLogFreedomPayEvent = /* @__PURE__ */ function(BiteLogFreedomPayEvent) {
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["None"] = 0] = "None";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["Payment"] = 1] = "Payment";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["PaymentError"] = 2] = "PaymentError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["Refund"] = 3] = "Refund";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["RefundError"] = 4] = "RefundError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["ReverseRefund"] = 5] = "ReverseRefund";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["TokenizationError"] = 6] = "TokenizationError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["IframeInitError"] = 7] = "IframeInitError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["TerminalDisconnected"] = 8] = "TerminalDisconnected";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["UpdateIdleTextError"] = 9] = "UpdateIdleTextError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["AuthTransaction"] = 10] = "AuthTransaction";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["AuthTransactionError"] = 11] = "AuthTransactionError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["SaleTransaction"] = 12] = "SaleTransaction";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["SaleTransactionError"] = 13] = "SaleTransactionError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["Logs"] = 14] = "Logs";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["InstallPal"] = 15] = "InstallPal";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["InstallPalError"] = 16] = "InstallPalError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["TerminalConnected"] = 17] = "TerminalConnected";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["PerformMaintenance"] = 18] = "PerformMaintenance";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["NativeTransaction"] = 19] = "NativeTransaction";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["NativeTransactionError"] = 20] = "NativeTransactionError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["CommandSync"] = 21] = "CommandSync";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["ReplayTransaction"] = 22] = "ReplayTransaction";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["ReplayTransactionError"] = 23] = "ReplayTransactionError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["QrCodeGenerate"] = 24] = "QrCodeGenerate";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["QrCodeGenerateError"] = 25] = "QrCodeGenerateError";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["TokenRetrieve"] = 26] = "TokenRetrieve";
	BiteLogFreedomPayEvent[BiteLogFreedomPayEvent["TokenRetrieveError"] = 27] = "TokenRetrieveError";
	return BiteLogFreedomPayEvent;
}(BiteLogFreedomPayEvent || {});
//#endregion
export { BiteLogFreedomPayEvent };

//# sourceMappingURL=bite_log_freedom_pay_event.js.map